// LABELS
import { getLabelFromStorage } from '@pb/utils'

export const applyToStyleboardModalHeadline = getLabelFromStorage('styleboard.add.item.to.board')
export const createStyleboardButtonTrigger = getLabelFromStorage('styleboard.create.board')
export const recentHeadline = getLabelFromStorage('styleboard.recent.heading')

export const myStorybookEmptyHeading = getLabelFromStorage('styleboard.explore.styles')
export const myStorybookEmptyText = getLabelFromStorage('styleboard.makes.it.easy')

export const commonSuccessText = getLabelFromStorage('styleboard.item.added.to.single')
